import Box from '@material-ui/core/Box';
// import { Collapse } from 'react-bootstrap';
import Collapse from '@material-ui/core/Collapse';
import { useContextLayout } from 'components/Layout/context';
import routePaths from 'constants/route-paths';
import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { useHistory } from 'react-router';
import { matchPath, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { getPath } from 'utils/path';
import { ActiveType, useContextAsideMenuList } from '../../../context';
import { FormListButton, SVGStyled } from '../../../style';

type Props = {
  name: string;
  children?: ReactNode;
  svgIcon: string;
  pathname?: string;
};
const BoxSubmenu = styled(Box)`
  & .menu-submenu {
    &.has-collapse {
      display: flex;
      & .menu-subnav .menu-item .menu-link .menu-text.active {
        color: ${(props) => props.theme.colors.kashmirBlue} !important;
      }
    }
    @media screen and (max-width: 767.99px) {
      & .menu-subnav {
        /* & .menu-item.menu-item-active .menu-link { */
        & .menu-item .menu-link {
          max-width: 168px;
          & .menu-text {
            max-width: 140px;
            white-space: normal;
            word-break: break-all;
          }
        }
      }
    }
  }
`;
const FormList = ({ name, children, svgIcon, pathname = '' }: Props) => {
  const { t } = useTranslation();
  const { active, setActiveMenu } = useContextAsideMenuList();
  const { setMenuActive } = useContextLayout();
  const history = useHistory();
  const location = useLocation();
  const [actived, setActived] = useState(false);

  const path = matchPath(location.pathname, {
    path: routePaths.GROUP + routePaths.RESIDENT,
  }) as { params: { residentId: string; groupId: string } };

  const params = {
    residentId: path?.params?.residentId,
    groupId: path?.params?.groupId,
  } as { groupId: string; residentId: string };

  const activeState = pathname
    ? history.location.pathname.includes(pathname)
    : active.secondary === name;

  const onClick = () => {
    if (pathname) {
      setActiveMenu({ secondary: '' } as ActiveType);
      setMenuActive('');
      if (activeState) {
        history.push(
          getPath([routePaths.GROUP, routePaths.RESIDENT], {
            groupId: params.groupId,
            residentId: params.residentId,
          }),
        );
      } else {
        history.push(
          getPath([routePaths.GROUP, routePaths.RESIDENT, pathname], {
            groupId: params.groupId,
            residentId: params.residentId,
          }),
        );
      }
      return;
    } else {
      setActiveMenu({ secondary: activeState ? '' : name } as ActiveType);
    }
  };

  return (
    <li
      className={`menu-item ${activeState && 'menu-item-active menu-item-open'}`}
      style={{
        paddingLeft: '25px',
      }}
    >
      <FormListButton className="menu-link my-1" onClick={() => onClick()}>
        <SVGStyled active={activeState}>
          <SVG src={svgIcon} />
        </SVGStyled>
        <span className={`menu-text ${activeState && 'active'}`}>{t(name)}</span>
        <i className={`${children && 'menu-arrow'} ${activeState && 'active'}`} />
      </FormListButton>
      <Collapse in={activeState} timeout={500}>
        <BoxSubmenu>
          <div className="menu-submenu has-collapse">
            <ul className="menu-subnav">{children}</ul>
          </div>
        </BoxSubmenu>
      </Collapse>
    </li>
  );
};

export default FormList;
